import { render, staticRenderFns } from "./AssetStream.vue?vue&type=template&id=638d4fd8&"
import script from "./AssetStream.vue?vue&type=script&lang=js&"
export * from "./AssetStream.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports